import { render, staticRenderFns } from "./EditFunctional.vue?vue&type=template&id=5b05937f&scoped=true&"
import script from "./EditFunctional.vue?vue&type=script&lang=js&"
export * from "./EditFunctional.vue?vue&type=script&lang=js&"
import style0 from "./EditFunctional.vue?vue&type=style&index=0&id=5b05937f&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b05937f",
  null
  
)

export default component.exports